import EnterprisePlatform from "./components/EnterprisePlatform";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import Products from "./components/Products";
import Signups from "./components/Signup";
import Whyus from "./components/Whyus";


export default function Home() {
  return (
    <>
  <Navbar/>
  <Hero/>
  <Products/>
  <EnterprisePlatform/>
  <Whyus/>
  <Signups/>
  <Footer/>
    </>
  );
}
